import { APIClient } from '@frontend/api-utils';
import { Job } from '@frontend/import/types';

export class ImportClient extends APIClient {
    public static readonly endpoint = '/import-api/v1';

    public static async importFile(accountId: string, file: File, update_existing_records = false): Promise<Job> {
        const formData = new FormData();
        formData.append('file', file);
        const response = await this.post(
            `${this.endpoint}/accounts/${accountId}/import${update_existing_records ? '?update_existing_records=true' : ''}`,
            formData
        );
        return await this.handleResponse<Job>(response);
    }
}
